function initModalLinks() {
	const modalLinks = document.querySelectorAll('.modal-card');
	const modal = document.querySelector('.modal-wrapper');
	const modalClose = document.querySelector('.modal-wrapper .close');

	if (modalLinks && modal && modalClose) {
		for (let i = 0; i < modalLinks.length; i++) {
			const modalLink = modalLinks[i];
			modalLink.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.add('show-modal');
				modal.querySelector('.modal-inner .html').innerHTML =
					modalLink.parentNode.querySelector('.modal-content').innerHTML;
			});
		}
		modalClose.addEventListener('click', () => {
			document.body.classList.remove('show-modal');
		});
		modal.addEventListener('click', (e) => {
			if (e.target.contains(modal)) {
				document.body.classList.remove('show-modal');
			}
		});
	}
}

window.onload = () => {
	initModalLinks();
};

(function ($) {
	$(document).on('facetwp-loaded', function () {
		initModalLinks();
	});
})(window.jQuery);
